<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.banner')"
    resource="banners"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/banners';

@Component
export default class Banners extends Vue {
  @Prop(String) type;

  // change nothing
  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'kind_eq',
      'page_position_eq'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'image',
      {
        key: 'kind',
        minWidth: 135,
      },
      'page_position',
      'position',
      {
        prop: 'target.url',
        label: this.$t('banner.targetUrl'),
      },
      {
        prop: 'target.appid',
        label: this.$t('banner.targetAppid')
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        key: 'image',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750x422`,
          props: {
            cropper: {
              width: 750,
              height: 422
            }
          }
        }
      },
      'kind',
      'page_position',
      {
        key: 'position',
        renderCell: {
          hint: this.$t('hint.positionColumn'),
        },
      },
      data.kind && data.kind !== 'image' && {
        prop: 'target.url',
        label: this.$t('banner.targetUrl'),
        renderCell: {
          required: data.kind !== 'external_mp_link',
          component: 'input'
        }
      },
      data.kind === 'external_mp_link' && {
        prop: 'target.appid',
        label: this.$t('banner.targetAppid'),
        renderCell: {
          required: true,
          component: 'input',
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'banners.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'banners.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/banners',
    name: 'banners.index',
    component: Banners,
    props: {
      type: 'index',
    }
  },
  {
    path: '/banners/new',
    name: 'banners.new',
    component: Banners,
    props: {
      type: 'new',
    }
  },
  {
    path: '/banners/:id',
    name: 'banners.show',
    component: Banners,
    props: {
      type: 'show',
    }
  },
  {
    path: '/banners/:id/edit',
    name: 'banners.edit',
    component: Banners,
    props: {
      type: 'edit'
    }
  }
]
</script>
